<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <b-form @submit="onSubmit3" @reset="onReset3" v-if="show">
          <b-form-group
            label="1. UTILIZA ETIQUETA DE ATENCIÓN"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_1"
                  :aria-describedby="ariaDescribedby"
                  name="question_1"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_1"
                  :aria-describedby="ariaDescribedby"
                  name="question_1"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_1"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="2. AMABILIDAD Y EMPATÍA"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_2"
                  :aria-describedby="ariaDescribedby"
                  name="question_2"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_2"
                  :aria-describedby="ariaDescribedby"
                  name="question_2"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_2"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group label="3. COMUNICACIÓN" v-slot="{ ariaDescribedby }">
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_3"
                  :aria-describedby="ariaDescribedby"
                  name="question_3"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_3"
                  :aria-describedby="ariaDescribedby"
                  name="question_3"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_3"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="4. CONFIANZA Y SEGURIDAD"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_4"
                  :aria-describedby="ariaDescribedby"
                  name="question_4"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_4"
                  :aria-describedby="ariaDescribedby"
                  name="question_4"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_4"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="5. CUMPLE PROCEDIMIENTO"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_5"
                  :aria-describedby="ariaDescribedby"
                  name="question_5"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_5"
                  :aria-describedby="ariaDescribedby"
                  name="question_5"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_5"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="6. DESCRIPCIÓN CRITERIO"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_6"
                  :aria-describedby="ariaDescribedby"
                  name="question_6"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_6"
                  :aria-describedby="ariaDescribedby"
                  name="question_6"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_6"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="7. ENTREGA INFORMACIÓN CORRECTA"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_7"
                  :aria-describedby="ariaDescribedby"
                  name="question_7"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_7"
                  :aria-describedby="ariaDescribedby"
                  name="question_7"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_7"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="8. REALIZA PROCEDIMIENTO CORRESPONDIENTE"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_8"
                  :aria-describedby="ariaDescribedby"
                  name="question_8"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_8"
                  :aria-describedby="ariaDescribedby"
                  name="question_8"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_8"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group label="9. ESCUCHA ACTIVA" v-slot="{ ariaDescribedby }">
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_9"
                  :aria-describedby="ariaDescribedby"
                  name="question_9"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_9"
                  :aria-describedby="ariaDescribedby"
                  name="question_9"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_9"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="10. HABILIDAD COMERCIAL"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_10"
                  :aria-describedby="ariaDescribedby"
                  name="question_10"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_10"
                  :aria-describedby="ariaDescribedby"
                  name="question_10"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_10"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="11. MANEJO DE TIEMPOS DE GESTIÓN"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_11"
                  :aria-describedby="ariaDescribedby"
                  name="question_11"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_11"
                  :aria-describedby="ariaDescribedby"
                  name="question_11"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_11"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="12. MOTIVO DE LLAMADA/SONDEO"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_12"
                  :aria-describedby="ariaDescribedby"
                  name="question_12"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_12"
                  :aria-describedby="ariaDescribedby"
                  name="question_12"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_12"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="13. TIPIFICACIÓN Y REGISTROS"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_13"
                  :aria-describedby="ariaDescribedby"
                  name="question_13"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_13"
                  :aria-describedby="ariaDescribedby"
                  name="question_13"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_13"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group label="14. VENTA CORRECTA" v-slot="{ ariaDescribedby }">
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_14"
                  :aria-describedby="ariaDescribedby"
                  name="question_14"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_14"
                  :aria-describedby="ariaDescribedby"
                  name="question_14"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_14"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group
            label="15. VOCACIÓN DE SERVICIO"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_15"
                  :aria-describedby="ariaDescribedby"
                  name="question_15"
                  value="1"
                  required
                  >Sí</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form3.selected_15"
                  :aria-describedby="ariaDescribedby"
                  name="question_15"
                  value="0"
                  required
                  >No</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 0</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form3.text_15"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-row class="text-center" align-v="center">
            <b-col>
              <b-button type="submit" class="Rectangle-Copy" variant="primary"
                >Guardar</b-button
              >
              <b-button type="reset" class="Rectangle-Copy-19" variant="danger"
                >Limpiar</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    evaluador: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      show: true,
      formSave: "Calidad Senati ATC",
      form3: {
        selected_1: null,
        selected_2: null,
        selected_3: null,
        selected_4: null,
        selected_5: null,
        selected_6: null,
        selected_7: null,
        selected_8: null,
        selected_9: null,
        selected_10: null,
        selected_11: null,
        selected_12: null,
        selected_13: null,
        selected_14: null,
        selected_15: null,
        text_1: null,
        text_2: null,
        text_3: null,
        text_4: null,
        text_5: null,
        text_6: null,
        text_7: null,
        text_8: null,
        text_9: null,
        text_10: null,
        text_11: null,
        text_12: null,
        text_13: null,
        text_14: null,
        text_15: null,
      },
    };
  },
  methods: {
    onSubmit3(event) {
      event.preventDefault();
      console.log(this.formSave);
      console.log(this.evaluador);
      var evaluacion = {
        interaction_id: this.$route.params.recording_id,
        form: this.formSave,
        evaluator: this.evaluador,
        evaluations: this.form3,
        questions: [
          {
            value: 1,
            text: "UTILIZA ETIQUETA DE ATENCIÓN",
          },
          {
            value: 2,
            text: "AMABILIDAD Y EMPATÍA",
          },
          {
            value: 3,
            text: "COMUNICACIÓN",
          },
          {
            value: 4,
            text: "CONFIANZA Y SEGURIDAD",
          },
          {
            value: 5,
            text: "CUMPLE PROCEDIMIENTO",
          },
          {
            value: 6,
            text: "DESCRIPCIÓN CRITERIO",
          },
          {
            value: 7,
            text: "ENTREGA INFORMACIÓN CORRECTA",
          },
          {
            value: 8,
            text: "REALIZA PROCEDIMIENTO CORRESPONDIENTE",
          },
          {
            value: 9,
            text: "ESCUCHA ACTIVA",
          },
          {
            value: 10,
            text: "HABILIDAD COMERCIAL",
          },
          {
            value: 11,
            text: "MANEJO DE TIEMPOS DE GESTIÓN",
          },
          {
            value: 12,
            text: "MOTIVO DE LLAMADA/SONDEO",
          },
          {
            value: 13,
            text: "TIPIFICACIÓN Y REGISTROS",
          },
          {
            value: 14,
            text: "VENTA CORRECTA",
          },
          {
            value: 15,
            text: "VOCACIÓN DE SERVICIO",
          },
        ],
      };
      console.log("onSubmite 3");
      console.log(evaluacion);
      this.axios
        .post("/api/createevaluation", evaluacion)
        .then((result) => {
          console.log(result);

          const itemFlush = {
            title: "Success",
            message: "Evaluacion Creada",
            time: 3000,
          };
          this.sendFlushData(itemFlush);

          this.form3.selected_1 = null;
          this.form3.selected_2 = null;
          this.form3.selected_3 = null;
          this.form3.selected_4 = null;
          this.form3.selected_5 = null;
          this.form3.selected_6 = null;
          this.form3.selected_7 = null;
          this.form3.selected_8 = null;
          this.form3.selected_9 = null;
          this.form3.selected_10 = null;
          this.form3.selected_11 = null;
          this.form3.selected_12 = null;
          this.form3.selected_13 = null;
          this.form3.selected_14 = null;
          this.form3.selected_15 = null;

          this.form3.text_1 = null;
          this.form3.text_2 = null;
          this.form3.text_3 = null;
          this.form3.text_4 = null;
          this.form3.text_5 = null;
          this.form3.text_6 = null;
          this.form3.text_7 = null;
          this.form3.text_8 = null;
          this.form3.text_9 = null;
          this.form3.text_10 = null;
          this.form3.text_11 = null;
          this.form3.text_12 = null;
          this.form3.text_13 = null;
          this.form3.text_14 = null;
          this.form3.text_15 = null;

          this.show = false;
          this.$nextTick(() => {
            this.show = true;
          });
        })
        .catch((error) => {
          console.log(error.response.status);
          const itemFlush = {
            title: "Error",
            message: "Intente Nuevamente",
            time: 3000,
          };
          this.sendFlushData(itemFlush);
          if (error.response.status === 403) {
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
          }
        });
    },
    onReset3(event) {
      event.preventDefault();
      // Reset our form values
      this.form3.selected_1 = null;
      this.form3.selected_2 = null;
      this.form3.selected_3 = null;
      this.form3.selected_4 = null;
      this.form3.selected_5 = null;
      this.form3.selected_6 = null;
      this.form3.selected_7 = null;
      this.form3.selected_8 = null;
      this.form3.selected_9 = null;
      this.form3.selected_10 = null;
      this.form3.selected_11 = null;
      this.form3.selected_12 = null;
      this.form3.selected_13 = null;
      this.form3.selected_14 = null;
      this.form3.selected_15 = null;

      this.form3.text_1 = null;
      this.form3.text_2 = null;
      this.form3.text_3 = null;
      this.form3.text_4 = null;
      this.form3.text_5 = null;
      this.form3.text_6 = null;
      this.form3.text_7 = null;
      this.form3.text_8 = null;
      this.form3.text_9 = null;
      this.form3.text_10 = null;
      this.form3.text_11 = null;
      this.form3.text_12 = null;
      this.form3.text_13 = null;
      this.form3.text_14 = null;
      this.form3.text_15 = null;
      const itemFlush = {
        title: "Info",
        message: "Formulario limpiado correctamente",
        time: 3000,
      };
      this.sendFlushData(itemFlush);
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    sendFlushData(item) {
      this.$emit("getFlushData", item);
    },
  },
};
</script>

<style>
</style>